import React, {FC, PropsWithChildren} from 'react';
import {observer} from 'mobx-react-lite';
import {UnnormalizedProps} from '@yosmanyga/core-style';
import {Button, Container, Icon, Text, useIcons} from '@yosmanyga/rich-ui';

const Basic = observer(
    ({
        templates,
        onGoToPayment,
    }: {
        templates: {
            layout: FC<PropsWithChildren & UnnormalizedProps>;
        };
        onGoToPayment?: () => void;
    }) => {
        const icons = useIcons();

        return <templates.layout
            padding={{
                top: 4,
            }}
        >
            <Container
                flow="column"
                align={{
                    cross: 'center',
                }}
            >
                <Text>
                    Your trial period has ended.
                </Text>
                <Text
                    margin={{
                        top: 1
                    }}
                >
                    To keep having this feature, please buy the Premium version.
                </Text>
                <Container
                    flow="row"
                    align={{
                        main: 'center',
                        cross: 'center',
                    }}
                    margin={{
                        top: 1,
                    }}
                >
                    <Button onClick={onGoToPayment}>
                        <Icon component={icons.actions.pay}/>
                        <Text>Go to payment</Text>
                    </Button>
                </Container>
            </Container>

        </templates.layout>
    }
);

export {Basic};
